import channelApi from "@api/channels" //eslint-disable-line
import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        loading: {
            channelList: false,
        },
        errors: {
            channelList: null,
        },
        channelList: [],
    },
    getters: {
        channel: ({ channel }) => channel,
        channelList: state => state.channelList,
        getLoadingState: state => name => state.loading[name],
        getErrorState: state => name => state.errors[name],
    },
    mutations: {
        setError(state, error) {
            Vue.set(state.errors, error.name, error.value)
        },
        setLoadingState(state, loading) {
            Vue.set(state.loading, loading.name, loading.value)
        },
        setChannel(state, data) {
            const channel = { ...data }
            Vue.set(state, 'channel', channel)
        },
        setChannelList(state, channels) {
            Vue.set(state, 'channelList', channels)
        },
        addChannel(state, channel) {
            state.channelList.push(channel)
        },
        updateChannel(state, channel) {
            const index = state.channelList.findIndex(oldChannel => oldChannel.uuid === channel.uuid)
            state.channelList.splice(index, 1, channel)
        },
    },
    actions: {
        getChannel({ commit }, uuid) {
            commit('setLoadingState', { name: 'channel', value: true })

            return channelApi
                .getChannel(uuid)
                .then(response => {
                    const { data } = response.data

                    commit('setChannel', data)
                })
                .catch(() => {
                    commit('setError', { name: 'channel', value: true })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'channel', value: false })
                })
        },
        clearChannel({ commit }) {
            commit('setChannel', {
                uuid: '',
                name: '',
                description: '',
            })
        },
        addChannel({ commit }, channelPayload) {
            commit('setLoadingState', { name: 'channelSave', value: true })
            commit('setError', { name: 'channelSave', value: null })

            return channelApi
                .addChannel(channelPayload)
                .then(response => {
                    const channel = {
                        ...response.data.data,
                    }
                    commit('addChannel', channel)
                })
                .catch(() => {
                    commit('setError', { name: 'channelSave', value: true })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'channelSave', value: false })
                })
        },
        updateChannel({ commit, state }) {
            commit('setLoadingState', { name: 'channelSave', value: true })
            commit('setError', { name: 'channelSave', value: null })

            return channelApi
                .updateChannel(state.channel.uuid, state.channel)
                .then(response => {
                    const channel = {
                        ...response.data.data,
                    }
                    commit('updateChannel', channel)
                })
                .catch(() => {
                    commit('setError', {
                        name: 'channelSave',
                        value: true,
                    })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'channelSave', value: false })
                })
        },
        setChannelList({ commit }) {
            commit('setLoadingState', { name: 'channelList', value: true })

            channelApi
                .getChannels()
                .then(response => {
                    const { data } = response.data

                    commit('setChannelList', data)
                })
                .catch(() => {
                    commit('setError', {
                        name: 'channelList',
                        value: true,
                    })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'channelList', value: false })
                })
        },
        clearError({ commit }, name) {
            commit('setError', {
                name,
                value: null,
            })
        },
        initializeChannelManager({ dispatch }) {
            dispatch('setChannelList')
        },
    },
}
